import { render } from "./nested.vue?vue&type=template&id=13bf99b7"
import script from "./nested.vue?vue&type=script&lang=js"
export * from "./nested.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__